import { APP_ENV_ENUM } from '@/common/env/envConfig';

/** 业务线代码——由type映射而来 */
export const BizCodes = {
  1: 'bike',
  2: 'moped',
  4: 'rentecar',
  6: 'hitch',
  10: 'battery',
  12: 'train',
  16: 'taxi',
  20: 'ticket',
  21: 'rentcar',
  27: 'haowu',
  30: 'recharge',
  34: 'insurance',
  35: 'charge',
  39: 'drive',
};

export const FreeDrawActivityCode: Partial<Record<APP_ENV_ENUM, string>> = {
  fat: 'MA2401094909777298494852346',
  uat: 'MA2407045434206272256222358',
  pro: 'MA2407307261981064756397057',
};
